export default {
  REGISTER_CLIENT_APP: 'REGISTER_CLIENT_APP',
  SET_TRANSLATIONS: 'SET_TRANSLATIONS',
};
